import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { ArticleSection, StyledButton, CustomInput } from "../components";
import { useTranslation } from "react-i18next";

import bg_03 from "./../images/Content/Backhaus-Häussler-34.jpg"

const Login: React.FunctionComponent = () => {
  const { t } = useTranslation(["login", "common"]);

  const [formData, setFormData] = useState({
    password: "",
    username: "",
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const contentStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Regular",
    fontWeight: 300,
    fontSize: "28px",
    lineHeight: "45px",
    color: "#342714",
    letterSpacing: ".05em"
  };

  return (
    <Container>
      <section style={{ marginBottom: "100px" }} id={"section_intro"}>
        <ArticleSection
          layout="article_right_bg"
          title={t("sections.intro.title")}
          content={
            <div>
              <Row>
                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div style={contentStyle}>{t("sections.intro.content")}</div>
                </Col>
              </Row>
              <Row style={{marginTop: 35}}>
                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                  <CustomInput
                    name="username"
                    label={t("form.fields.username")}
                    required
                    value={formData.username}
                    onChange={handleInputChange}
                  />
                </Col>
                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                  <CustomInput
                    name="password"
                    label={t("form.fields.password")}
                    type="password"
                    required
                    value={formData.password}
                    onChange={handleInputChange}
                  />
                </Col>
                <div style={{ justifyContent: "right", display: "flex" }}>
                  <StyledButton title={t("form.button")} onClick={() => { console.log("Button clicked"); }} />
                </div>
              </Row>
            </div>
          }
          imageUrl={bg_03}
          backgroundColor="#DDEBEA"
        />
      </section>
    </Container>
  );
}

export default Login;
